export const USER_TAGS_ADD = 'USER_TAGS_ADD';
export const USER_TAGS_REMOVE = 'USER_TAGS_REMOVE';
export const USER_ADD = 'USER_ADD';
export const USER_EDIT = 'USER_EDIT';
export const USER_REMOVE = 'USER_REMOVE';
export const USER_RESET = 'USER_RESET';

// --- DATA MODEL --- //

export interface UsersState
{
    current: UserState;
    registeredUsers: {
        [account: string]: UserState;
    };
}

export interface UserState
{
    account: string;
    username: string;
    id: string;
    type: string;
    isElevatedUser: boolean;
}

// --- ACTION MODEL --- //

interface AddUserAction
{
    type: typeof USER_ADD;
    account: string;
    username: string;
    id: string;
    userType: string;
    isElevatedUser: boolean;
}

interface EditUserAction
{
    type: typeof USER_EDIT;
    account: string;
    username: string;
    id: string;
    userType: string;
    isElevatedUser: boolean;
}

interface RemoveUserAction
{
    type: typeof USER_REMOVE;
    account: string;
}

export type UserAction = AddUserAction | EditUserAction | RemoveUserAction;

// ------------------- //